<div horizontal="between" class="slds-flex ds-h-sizes-width--full">
	<div vertical="center" class="slds-p-around--small">
		<eff-icon name="error" size="sm" weight="filled" class="slds-m-right--small ds-toast__error-icon" />
		<div class="ds-text--small ds-h-colors-txt--black-5">
			{{ message().text }}
			@if (errorReferenceId()) {
				<div vertical="center" class="slds-m-top--xx-small">
					<div
						class="ds-h-text-weight--semibold slds-truncate"
						[matTooltip]="errorReferenceLabel() + ': ' + errorReferenceId()"
						matTooltipClass="ds-tooltip-width-big"
						showTooltipIfTruncated
					>
						@if (errorSentryLink()) {
							<a [href]="errorSentryLink()" target="_blank" rel="noopener noreferrer"
								>{{ errorReferenceLabel() }}: {{ errorReferenceId() }}</a
							>
						} @else {
							{{ errorReferenceLabel() }}: {{ errorReferenceId() }}
						}
					</div>
					<button
						mat-icon-button
						type="button"
						class="slds-m-left--xx-small ds-button-rectangle--sm"
						(click.stop)="copyText()"
					>
						<eff-icon name="content-copy" [size]="14" class="ds-h-colors-txt--black-1" />
					</button>
				</div>
			}
		</div>
	</div>

	<div class="slds-flex slds-shrink-none">
		<button
			type="button"
			mat-button
			class="ds-button--no-radius slds-p-horizontal--small ds-toast__button"
			(click.stop)="handleRefresh()"
			[disabled]="reloadPending"
		>
			Refresh
		</button>
		<button
			type="button"
			mat-icon-button
			class="ds-toast__button ds-toast__button-close"
			(click.stop)="handleClose()"
			[disabled]="reloadPending"
		>
			<eff-icon name="close" [size]="22" />
		</button>
	</div>
</div>
